import { render, staticRenderFns } from "./mailserver-ansible.vue?vue&type=template&id=0e431201&scoped=true&"
import script from "./mailserver-ansible.vue?vue&type=script&lang=js&"
export * from "./mailserver-ansible.vue?vue&type=script&lang=js&"
import style0 from "./mailserver-ansible.vue?vue&type=style&index=0&id=0e431201&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e431201",
  null
  
)

export default component.exports